import React, { useState } from 'react'
import { ChevronDownIcon, ChevronRightIcon, ClipboardIcon } from '@bizfirst/common-react'

/**
 * ActivityLogViewer - Displays activity timeline
 *
 * Simplified implementation without external dependencies
 */
interface ActivityLogViewerProps {
  activities?: string[]
}

export default function ActivityLogViewer({ activities }: ActivityLogViewerProps): React.ReactElement {
  const [expanded, setExpanded] = useState(true)
  const activityList = activities || []

  if (activityList.length === 0) {
    return <div style={{ color: 'var(--text-secondary)', fontSize: '12px' }}>No activities logged</div>
  }

  return (
    <div style={{ marginBottom: '12px' }}>
      <button
        onClick={() => setExpanded(!expanded)}
        style={{
          background: 'none',
          border: 'none',
          padding: '0 0 8px 0',
          cursor: 'pointer',
          fontSize: '12px',
          fontWeight: 600,
          color: 'var(--text-primary)',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        {expanded ? <ChevronDownIcon size={12} /> : <ChevronRightIcon size={12} />}
        <ClipboardIcon size={14} /> Activity Log ({activityList.length})
      </button>

      {expanded && (
        <div
          style={{
            padding: '8px 12px',
            background: 'var(--bg-secondary)',
            borderRadius: '4px',
            fontSize: '11px',
            fontFamily: 'monospace',
            color: 'var(--text-secondary)',
            maxHeight: '200px',
            overflowY: 'auto',
          }}
        >
          {activityList.map((activity, idx) => (
            <div key={idx} style={{ lineHeight: '1.6', whiteSpace: 'pre-wrap' }}>
              {activity}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
